export default __webpack_public_path__ + "static/media/baner-m.72f8e593.jpg";